export const root = "r1su3dxr";
export const instructorAsImgHeader = "i1b0faqh";
export const guideInfoFooter = "g51d40m";
export const blurredImgHeader = "b113e935";
export const overflow = "o18rejjx";
export const divider = "d1dgjmiu";
export const shadow = "s1kse8bn";
export const action = "a1uliysg";
export const isLink = "irq5n08";
export const hasFooter = "hzdvpi7";
export const hasHeader = "h8d7wi7";
export const hasBackgroundImage = "hru17e";
export const overlay = "o1husl1d";
export const contentWrapper = "c1dqln0c";

/* 16:9 ratio hack */
export const fixedAspectRatio = "f1w5eq8v";
export const removePadding = "rubq3jy";
export const content = "c13p11gy";
export const footer = "fwg78fy";
export const header = "h1llsj21";
export const backgroundImage = "blhced";
export const lockedDisplay = "l12274bk";
export const bannerImage = "boa2c5c";
export const unsetHeightOnDesktop = "ug2x54x";

// Color variants for bg
export const primary = "p1i772se";
export const secondary = "s1mjger3";
export const primaryMuted = "p150esn0";
export const standard = "ss9uona";
export const tertiary = "t1w15j5e";
export const classic = "cxnrbtm";
export const whiteText = "wezpu1f";
export const fluid = "f1kmeohx";

// Special variant for desktop views long/wide card view
export const wide = "w13n45hy";
export const schedule = "snr376u";
export const zoomImage = "z1vg3ynm";
export const iconImage = "i13n3d8d";
export const iconImageContainer = "i14yz4ws";
export const guideCoverImage = "gxknx4i";
export const badges = "bwx799x";
export const newBadge = "n11fskl8";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");